import { render, staticRenderFns } from "./DealCard.vue?vue&type=template&id=d2ac0492&scoped=true"
import script from "./DealCard.vue?vue&type=script&lang=js"
export * from "./DealCard.vue?vue&type=script&lang=js"
import style0 from "./DealCard.vue?vue&type=style&index=0&id=d2ac0492&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2ac0492",
  null
  
)

export default component.exports